import React from "react";
import Joke from "../components/Joke";
import Header from "../components/Header";
import WorkList from "../components/WorkList";
import Skill from "./Skill";
import AboutMe from "../components/AboutMe";
import Contact from "../components/Contact";

const About = () => {
  return (
    <>
      <Header />
      <Joke />
      <WorkList />
      <Skill />
      <AboutMe />
      <Contact />
    </>
  );
};

export default About;
